import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutGrid, Flame, ScanLine, GraduationCap, FolderOpen } from 'lucide-react';
import { useLanguage } from '../i18n';

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const items = [
    { path: '/dashboard', icon: LayoutGrid, label: t('navDashboard'), testid: 'bottom-nav-dashboard' },
    { path: '/pitch', icon: Flame, label: t('navPitch'), testid: 'bottom-nav-pitch' },
    { path: '/analyze', icon: ScanLine, label: t('navAnalyze'), testid: 'bottom-nav-analyze', center: true },
    { path: '/academy', icon: GraduationCap, label: t('navAcademy'), testid: 'bottom-nav-academy' },
    { path: '/library', icon: FolderOpen, label: t('navLibrary'), testid: 'bottom-nav-library' },
  ];

  const isActive = (path) => {
    if (path === '/analyze') return location.pathname === '/analyze' || location.pathname.startsWith('/result');
    if (path === '/academy') return location.pathname.startsWith('/academy') || location.pathname.startsWith('/course');
    if (path === '/pitch') return location.pathname.startsWith('/pitch');
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/[0.06] bg-[rgba(18,18,18,0.85)] backdrop-blur-xl pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-6xl mx-auto h-16 grid grid-cols-5">
        {items.map(({ path, icon: Icon, label, testid, center }) => {
          const active = isActive(path);
          return (
            <button key={path} onClick={() => navigate(path)} data-testid={testid} className="relative flex flex-col items-center justify-center gap-1">
              {center ? (
                <span
                  className={`w-11 h-11 -mt-5 rounded-[16px] flex items-center justify-center bg-[#22C55E] transition-shadow ${
                    active ? 'shadow-[0_0_24px_rgba(34,197,94,0.45)]' : 'shadow-[0_8px_20px_rgba(34,197,94,0.25)]'
                  }`}
                >
                  <Icon size={20} className="text-[#06210F]" />
                </span>
              ) : (
                <Icon size={19} className={active ? 'text-white' : 'text-white/40'} />
              )}
              <span className={`text-[10px] font-mono ${active ? 'text-white' : 'text-white/40'}`}>{label}</span>
              {active && !center && <span className="ss-nav-dot absolute top-2 w-1 h-1 rounded-full bg-white" />}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
